import { render } from "./CurrencySwitch.vue?vue&type=template&id=1300509c"
import script from "./CurrencySwitch.vue?vue&type=script&lang=js"
export * from "./CurrencySwitch.vue?vue&type=script&lang=js"

import exportComponent from "/home/admin/domains/web3.owatts.io/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__